// this is an autogenerated file from DesignSystem/CreateNewProfessionalModal/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CreateNewProfessionalModal(
  $person_details: json
  $contact_methods: json
  $office_details: json
  $employee_type_id: numeric
  $patient_id: numeric
  $addresses: json
) {
  insert_other_professional_relationship(
    args: {
      person_details: $person_details
      contact_methods: $contact_methods
      office_details: $office_details
      employee_type_id: $employee_type_id
      patient_id: $patient_id
      addresses: $addresses
    }
  ) {
    id
  }
}

`